var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.781 5.62421C12.5075 5.62421 13.1769 6.01824 13.5296 6.65348L14.7995 8.94095C15.1198 9.51795 15.1348 10.2158 14.8397 10.8061L13.4257 13.6342C13.4257 13.6342 13.881 15.9751 15.7866 17.8807C17.6922 19.7864 20.0253 20.2338 20.0253 20.2338L22.8527 18.8202C23.4433 18.5248 24.1417 18.5401 24.7189 18.861L27.015 20.1375C27.6496 20.4904 28.0431 21.1594 28.0431 21.8855L28.0431 23.1878C28.0431 25.7714 25.6388 27.6339 23.2205 26.7245C19.9669 25.5009 15.77 23.521 12.9582 20.7092C10.1463 17.8973 8.16643 13.7004 6.94287 10.4468C6.03345 8.02851 7.8959 5.62421 10.4795 5.62421L11.781 5.62421Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.18b48ac06c3726f26baf385f8f7f464b.svg";
export { ForwardRef as ReactComponent };